import React, { useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, themeBalham } from 'ag-grid-community';
import { Carte } from '../../../utils/types/Carte';

const SoldesCartesGrid: React.FC<{ items: Carte[] }> = ({ items }) => {
    const [columnDefs] = useState<ColDef<Carte>[]>([
        { field: 'numero', headerName: 'Numéro' },
        { field: 'type', headerName: 'Type' },
        { field: 'description', headerName: 'Porteur' },
        { field: 'designationArticle', headerName: 'Produit', valueGetter: (params) => params.data?.designationArticle ?? 'Multi-produit' },
        {
            field: 'solde',
            headerName: 'Solde',
            type: 'numericColumn',
            valueFormatter: (params) => {
                const solde = params.value;
                if (solde == null) return '';

                const idArticle = params.data?.idArticle;

                if (idArticle == null) {
                    return new Intl.NumberFormat('fr-FR', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }).format(solde);
                } else {
                    return `${solde.toFixed(2).replace('.', ',')} L`;
                }
            },
        },
    ]);

    return (
        <div style={{ width: '100%', height: 200 }}>
            <AgGridReact theme={themeBalham} rowData={items} columnDefs={columnDefs} defaultColDef={{ flex: 1, resizable: true, minWidth: 100 }} overlayNoRowsTemplate="<span style='padding: 10px;'>Aucune donnée ...</span>" />
        </div>
    );
};

export default SoldesCartesGrid;
